import C from '../../constants';

export function isLoading(state = {}, action) {
    switch (action.type) {
        case C.SET_IS_LOADING:
            return action.payload;

        default:
            return state;
    }
}

export function showAddPropertyModal(state = {}, action) {
    switch (action.type) {
        case C.SHOW_ADD_PROPERTY_MODAL:
            return action.payload;

        default:
            return state;
    }
}

export function showAddListingModal(state = {}, action) {
    switch (action.type) {
        case C.SHOW_ADD_LISTING_MODAL:
            return action.payload;

        default:
            return state;
    }
}

export function showInviteTenantModal(state = {}, action) {
    switch (action.type) {
        case C.SHOW_INVITE_TENANT_MODAL:
            return action.payload;

        default:
            return state;
    }
}

export function flowKeys(state = {}, action) {
    switch (action.type) {
        case C.ADD_FLOW_KEY:
            return [...state, action.payload];

        case C.SET_FLOW_KEY:
            return Object.assign([], state).map((key, i) => {
                return key.id === action.payload.id ? {
                    id: key.id,
                    size: key.size,
                    value: Math.min(Math.max(action.payload.value, 0), key.size - 1),
                    direction: key.value > action.payload.value ? -1 : 1
                } : key;
            });

        case C.INC_FLOW_KEY:
            return Object.assign([], state).map((key, i) => {
                return key.id === action.payload.id ? {
                    id: key.id,
                    size: key.size,
                    value: Math.min(Math.max(key.value + action.payload.value, 0), key.size - 1),
                    direction: action.payload.value > 0 ? 1 : -1
                } : key;
            });

        default:
            return state;
    }
}

export function modals(state = {}, action) {
    switch (action.type) {
        case C.DISPLAY_CONFIRM_MODAL:
            return !!(state.find((i) => i.id === action.payload.id)) ? state : [...state, action.payload];

        case C.HIDE_CONFIRM_MODAL:
            return state.filter((i) => i.id !== action.payload);

        case C.SET_CONFIRM_MODAL_ACTING:
            return state.map((key, i) => {
                return key.id === action.payload.id ? {
                    ...key,
                    acting: action.payload.acting
                } : key;
            });

        case C.DISPLAY_MODAL:
            return !!(state.find((i) => i.id === action.payload.id)) ? state : [...state, action.payload];

        case C.HIDE_MODAL:
            return state.filter((i) => i.id !== action.payload);

        case C.UPDATE_MODAL:
            return state.map((modal) => {
                return modal.id === action.payload.id ? {...modal, ...action.payload} : modal;
            });

        default:
            return state;
    }
}

export function overlays(state = {}, action) {
    switch (action.type) {
        case C.DISPLAY_OVERLAY:
            return !!(state.find((i) => i.id === action.payload.id)) ? state : [...state, action.payload];

        case C.HIDE_OVERLAY:
            return state.filter((i) => i.id !== action.payload);

        case C.UPDATE_OVERLAY:
            return state.map((overlay) => {
                return overlay.id === action.payload.id ? {...overlay, ...action.payload} : overlay;
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/displayReducer.js